"use client";

import { useState, useEffect } from "react";
import { Container } from "react-bootstrap";
import "../../Assests/css/vendors/BalanceScreen.css";
import Header2 from "../Sections/Header";
import { useLocation } from "react-router-dom";

import { loadStripe } from "@stripe/stripe-js";
import {
  update_deposit_payment_for_user,
  server_post_data,
  Payment_KEY_STRIPE,
} from "../../ServiceConnection/serviceconnection";
import { computeTodayDate, handleError } from "../../CommonJquery/CommonJquery";
const stripePromise = loadStripe(Payment_KEY_STRIPE);
const DepositBalanceScreen = () => {
  const location = useLocation();

  // Initial balance data
  const [BookingData, setBookingData] = useState([]);
  const [balanceData, setBalanceData] = useState({
    deposit: { due: 100.0, due_pay: 350.0, payment: 0.0 },
  });

  // State for partial payment amount
  const [partialPayment, setPartialPayment] = useState();
  const [paymentNote, setPaymentNote] = useState("");
  const handleNoteChange = (value) => {
    setPaymentNote(value);
  };
  // State for validation errors
  const [validationErrors, setValidationErrors] = useState({});
  const [totalDue, settotalDue] = useState(250);

  // Add fixed header class on mount
  useEffect(() => {
    // Add class to header if it exists
    const headerElement = document.querySelector("header");
    if (headerElement) {
      headerElement.classList.add("header-fixed");
    }

    return () => {
      // Clean up on unmount
      if (headerElement) {
        headerElement.classList.remove("header-fixed");
      }
    };
  }, []);

  useEffect(() => {
    if (location.state) {
      const passedData = location.state;
      setBookingData(passedData.bookingData);
      setBalanceData(passedData.balanceData);
      console.log("shubham", passedData);
      //settotalDue(parseFloat(250));
    }
  }, [location]);

  // Handle partial payment input change with validation
  const handlePartialPaymentChange = (value) => {
    // Parse input value to number
    const paymentValue = Number.parseFloat(value) || 0;

    // Create a copy of current errors
    const errors = { ...validationErrors };

    // Check if payment is at least $10
    if (paymentValue < 10 && paymentValue !== 0) {
      errors.partialPayment = `Minimum payment amount is $10.00`;
    } else {
      // Clear error if valid
      delete errors.partialPayment;
    }

    // Update validation errors
    setValidationErrors(errors);

    // Update partial payment value
    setPartialPayment(paymentValue);

    // Calculate proportional distribution of payment across all items
    if (paymentValue > totalDue) {
      errors.partialPayment = `Minimum payment amount is $10.00`;
    } else {
      setBalanceData(parseFloat(totalDue)-parseFloat(paymentValue));
    }
  };

  // Format currency
  const formatCurrency = (amount) => {
    console.log(amount);
    if (amount == undefined) {
      return "$0.00";
    }
    return `$${Number.parseFloat(amount).toFixed(2)}`;
  };

  const handleSubmit = async () => {
    // Check if there are any validation errors before proceeding
    if (Object.keys(validationErrors).length > 0) {
      handleError("Please correct payment amount before proceeding.");
      return;
    }

    // Check if payment amount is greater than 0
    if (partialPayment <= 0) {
      handleError("Payment amount must be greater than 0.");
      return;
    }

    // Check if payment amount is at least $10
    if (partialPayment < 10) {
      handleError("Minimum payment amount is $10.00");
      return;
    }

    const stripe = await stripePromise;
    const date_set = computeTodayDate();
    const fd = new FormData();
    fd.append("payment_date", date_set);
    fd.append("booking_id", BookingData.primary_id);
    fd.append("user_id", BookingData.user_id);
    fd.append("car_id", BookingData.car_id);
    fd.append("contract_id", BookingData.contract_id);
    fd.append("total_amount_paid", partialPayment);
    fd.append("transaction_note", paymentNote || "Stripe on " + date_set);
    fd.append("transaction_id", "");
    fd.append("entry_from", "1");
    fd.append("click_from", "0");
    fd.append("payment_mode", "Stripe");

    const Response = await server_post_data(update_deposit_payment_for_user, fd);
    console.log(Response);
    if (Response.error) {
      handleError(Response.message);
      return;
    } else {
    }

    const confirmPayment = await stripe.redirectToCheckout({
      sessionId: Response.message.clientSecret,
    });

    if (confirmPayment.error) {
      // setMessage(confirmPayment.error.message);
    } else {
      // setMessage("Payment Successful!");
    }
  };

  return (
    <>
      <Header2 />
      <div className="compact-wrapper">
        <Container className="balance-container">
          <div className="balance-card-container">
            <div className="balance-header-content">
              <h2 className="balance-section-title">Pay Deposit</h2>
              {/* <p className="balance-section-subtitle">Due Amounts</p> */}
            </div>

            <div className="balance-card">
              {/* Rent */}

              <div className="balance-item balance-totalinput">
                <div className="balance-total">
                  <span className="balance-total-label">Total Deposit</span>
                  <span className="balance-total-amount">
                    {formatCurrency(totalDue)}
                  </span>
                </div>

                <div className="balance-payment-section ">
                  <label className="balance-partial-label">
                    Payment Amount{" "}
                    <span className="balance-min-payment">(Min. Amt. $10)</span>
                  </label>

                  <div className="balance-partial-payment">
                    <div className="balance-payment-input">
                      <span className="balance-currency-symbol">$</span>
                      <input
                        type="number"
                        value={partialPayment}
                        onChange={(e) =>
                          handlePartialPaymentChange(e.target.value)
                        }
                        className={`balance-input ${
                          validationErrors.partialPayment ? "error-input" : ""
                        }`}
                        placeholder="Enter amount"
                      />
                    </div>
                    {validationErrors.partialPayment && (
                      <div className="error-message">
                        {validationErrors.partialPayment}
                      </div>
                    )}
                  </div>
                </div>
              </div>
              {/* Note Field */}
              <div className="balance-item balance-note-container">
                <div className="balance-note-wrapper">
                  <label className="balance-item-label">Payment Note</label>
                  <textarea
                    className="balance-note-input"
                    placeholder="Add a note for this payment (optional)"
                    value={paymentNote}
                    onChange={(e) => handleNoteChange(e.target.value)}
                  ></textarea>
                </div>
              </div>
            </div>

            {/* Total and Pay Now - Bottom of card */}
            <div className="balance-footer">
              <button
                className="balance-pay-button"
                type="button"
                onClick={() => handleSubmit()}
                disabled={
                  Object.keys(validationErrors).length > 0 ||
                  partialPayment <= 0
                }
              >
                <span className="balance-pay-icon">$</span> PAY NOW
              </button>
            </div>
          </div>
        </Container>
      </div>
    </>
  );
};

export default DepositBalanceScreen;
